// Google Analytics 4 Configuration
export const GA_TRACKING_ID = 'G-VTVNJWHMZT';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Eventos específicos para CTA
export const trackCTAClick = (ctaName, section) => {
  event({
    action: 'cta_click',
    category: 'engagement',
    label: `${section} - ${ctaName}`,
    value: 1
  });
};

// Eventos para videos
export const trackVideoPlay = (videoName, section) => {
  event({
    action: 'video_play',
    category: 'engagement',
    label: `${section} - ${videoName}`,
    value: 1
  });
};

// Eventos para scroll
export const trackScrollDepth = (depth) => {
  event({
    action: 'scroll_depth',
    category: 'engagement',
    label: `${depth}%`,
    value: depth
  });
};

// Eventos para formularios
export const trackFormSubmit = (formName) => {
  event({
    action: 'form_submit',
    category: 'conversion',
    label: formName,
    value: 1
  });
};
